'use client';

import { Avatar, Label, Description, Button } from '@heroui/react';
import { ReactNode } from 'react';

export interface UserProps {
  name: string;
  description?: string;
  avatarUrl?: string;
  fallback?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'accent' | 'success' | 'warning' | 'danger';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost';
  onPress?: () => void;
}

export const User = ({
  name,
  description,
  avatarUrl,
  fallback,
  size = 'md',
  color = 'default',
  variant = 'ghost',
  onPress,
}: UserProps) => {
  const content = (
    <div className="flex items-center gap-3">
      <Avatar size={size} color={color}>
        {avatarUrl && <Avatar.Image src={avatarUrl} alt={name} />}
        <Avatar.Fallback>{fallback || name.charAt(0)}</Avatar.Fallback>
      </Avatar>
      <div className="flex flex-col items-start">
        <Label className="font-semibold">{name}</Label>
        {description && <Description>{description}</Description>}
      </div>
    </div>
  );

  if (onPress) {
    return (
      <Button onPress={onPress} variant={variant} className="h-auto p-2 justify-start font-normal">
        {content}
      </Button>
    );
  }

  return content;
};
